import GaugeChart from 'react-gauge-chart';
import { calculateOverallAverageCustomerRating } from '../../utilities/ratingsUtils';
import useFetchData from '../../hooks/ValuatorHooks/useFetchData';
import LoadingComponent from '../../components/LoadingComponent';

const CustomerSatisfactionGauge = ({companyId}) => {
  const { data: customerValuations, loading, error } = useFetchData(`companies/${companyId}/cases`);

  const averageRating = calculateOverallAverageCustomerRating(customerValuations || []);

  const chartValue = averageRating / 5;

    if (loading) return <LoadingComponent />;
    if (error) return <div>Error: {error}</div>;

    const chartDescription = (
        <div style={{ textAlign: 'center' }}>
          <h2 className='sub-header'>Kundetilfredshed</h2>
          <p>Gennemsnitlig Rating i virksomeheden {averageRating.toFixed(2)} / 5</p>
          <p>Denne måling er baseret på Kundetilfredshed</p>
        </div>
      );
    
      return (
        <div>
          {chartDescription}
          <GaugeChart 
            id="customer-satisfaction-gauge"
            nrOfLevels={20} 
            arcsLength={[0.3, 0.4, 0.3]}
            colors={['#FF471A', '#FFC371', '#57D500']}
            percent={chartValue} 
            arcPadding={0.02} 
            cornerRadius={3}
            needleColor="#333"
            needleBaseColor="#333"
            hideText
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 5%' }}>
            <span>0</span>
            <span>2.5</span>
            <span>5</span>
          </div>
        </div>
      );
    };

export default CustomerSatisfactionGauge;
